import { Controller } from "remult";

@Controller("status-methods")
export class StatusMethods {}
